<template>
  <div class="delivery-time">
    <icon-truck />

    <span
      v-if="immediateDelivery"
      class="delivery-time__text text-mobile-paragraph-s-bold text-desktop-paragraph-s-bold"
      v-text="$string('product.immediate_delivery')"
    />

    <span
      class="delivery-time__text text-mobile-paragraph-s-medium text-desktop-paragraph-s-medium"
      v-text="deliveryTimeText"
    />
  </div>
</template>

<script>
/**
 * Vue: Delivery time (delivery-time)
 * -----------------------------------------------------------------------------
 * To show customers when the expected delivery date range for their parcel is.
 *
 *  @param {Boolean} [isGiftCard] - Indicates if Product is Giftcard.
 */
import IconTruck from '~icons/general/truck.svg';

export default {
  name: 'DeliveryTime',

  components: {
    IconTruck,
  },

  props: {
    isGiftCard: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    /**
     * Compute if delivery is immediate
     * @returns {Boolean}
     */
    immediateDelivery() {
      return this.$variable('product.immediateDelivery')?.includes(
        this.$variable('product.deliveryTime'),
      );
    },

    /**
     * Compute delivery time text.
     * @returns {String}
     */
    deliveryTimeText() {
      if (this.isGiftCard) {
        return this.$string('product.delivery_time_giftcard');
      }
      return this.$string('product.delivery_time', {
        replace: { time: this.$variable('product.deliveryTime') },
      });
    },
  },
};
</script>

<style lang="scss">
@import './delivery-time';
</style>
